import type { Plugin } from 'vue'

import { UCard } from '@unpack-ui/components/card'

export default [UCard] as Plugin[]
